<form [formGroup]='formGroup'
      class='widget'>
  <div [style.margin-bottom]="marginBottom" class='form-group h-100'>
    <pt-input-label
      *ngIf='label'
      [fontWeightBold]='fontWeightBold'
      [inputId]='internalInputId'
      [isRequired]='required'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <textarea
      *ngIf='maxLength || maxLength === 0; else textareaNoLengthLimit'
      [class.is-invalid]='formGroup.invalid'
      [id]='internalInputId'
      [maxLength]='maxLength' [rows]='minRow'
      aria-describedby='ptWInputHelp'
      autocomplete='off'
      class='form-control form-control-sm'
      formControlName='value'
      placeholder='{{placeholder}}'
      style="height: 100%;">
    </textarea>
    <div *ngIf="maxLength || maxLength === 0" class="form-text" style="text-align: right">{{formGroup.controls.value.value?.length || 0}}/{{maxLength}}</div>

    <ng-template #textareaNoLengthLimit>
          <textarea
            [class.is-invalid]='formGroup.invalid'
            [id]='internalInputId'
            [ngStyle]="{'min-height': (minRow * 20) + 'px'}" [rows]='minRow'
            aria-describedby='ptWInputHelp'
            autocomplete='off'
            class='form-control form-control-sm'
            formControlName='value'
            placeholder='{{placeholder}}'
            style="height: 100%;">
    </textarea>
    </ng-template>
    <small [innerHTML]='help'
           class='form-text text-muted' id='ptWInputHelp_{{internalInputId}}'>
    </small>
  </div>
</form>
